import {useEffect,useState} from 'react'
import util from "../../utils/utils";
import axios from 'axios';
import { useNavigate,useSearchParams } from 'react-router-dom';
import useGetSavedFoldList from '../../hooks/useGetSavedFoldList';
import useMarkAction from '../../hooks/useMarkAction';
import useGetSavedContent from './hooks/useGetSavedContent'
import { FoldFormModal } from './components/FoldForm';
import {SavedContent} from './components/SavedContent'

export const Collections = () => {
  const {savedFoldListLoading, savedFoldListData, savedFoldListRefresh} = useGetSavedFoldList()
  const [searchParams] = useSearchParams();
  const {deleteSavedContentAction, deleteSavedFoldAction} = useMarkAction()
    const [editingFold,setEditingFold] = useState()
    const [checkingFold,setCheckingFold] = useState()
    const { savedContentLoading, 
        savedContentData, 
        getSavedContentAction    
    } = useGetSavedContent()
    const [content, setContent] = useState()
    useEffect(()=>{
        if(!checkingFold && savedFoldListData && savedFoldListData?.length > 0){
            setCheckingFold(savedFoldListData[0]?.fold_id);getSavedContentAction(savedFoldListData[0]?.fold_id)
        }
    },[savedFoldListData])
    const renderFoldList = ()=>{
        return (
        <div className={`bg-base-100 p-0 overflow-y-auto ${checkingFold ? 'lg:w-2/5 border-r m-auto' : 'm-auto'} min-w-xl max-w-3xl h-full w-full`}>
            {
                savedFoldListLoading ? 
                <div className="flex flex-col gap-4 w-full mb-2 p-4">
                    <div className="skeleton h-6 w-full"></div>
                    <div className="skeleton h-6 w-full"></div>
                    <div className="skeleton h-6 w-full"></div>
                </div> : 
                <div className=''>
                    {
                        savedFoldListData?.length > 0 ? 
                        <div>
                        {savedFoldListData?.map((item, index) => {return (
                                <div className={`${item?.fold_id === checkingFold ? 'bg-base-200' : ''} flex justify-between items-center w-full pl-6 p-4 ${index===savedFoldListData?.length-1 ? '' : 'border-b'}`}>
                                    <div className='w-full'>
                                        <div className={`text-lg font-bold truncate pb-2 cursor-default ${item?.fold_id === checkingFold ? 'text-primary' : ''}`} onClick={()=>{setCheckingFold(item?.fold_id);getSavedContentAction(item?.fold_id)}}>
                                            {item?.fold_name}
                                        </div>
                                        {item?.fold_description && <div className='text-secondary truncate pb-2'>
                                            {item?.fold_description}
                                        </div>}
                                        <div className={`2xl:flex justify-between items-center w-full`}>
                                            <div className='text-secondary flex-1'>
                                                <span>
                                                    {item?.content_len}条内容
                                                </span>
                                                <span>
                                                    {item?.newest_content_time && ` · 最新收藏时间 ${util.dateTransformToCN(item?.newest_content_time)}`}
                                                </span>
                                            </div>
                                            <div>
                                                <button className="btn btn-ghost btn-sm" onClick={()=>{setEditingFold(item);document.getElementById('my_fold_form_modal').showModal()}}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                                    </svg>
                                                    编辑
                                                </button>
                                                <div className="dropdown dropdown-top dropdown-end">
                                                    <div tabIndex={0} role="button" className="btn btn-ghost btn-sm mt-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                                        </svg>
                                                        删除
                                                    </div>
                                                    <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-28">
                                                        <li><a onClick={()=>deleteSavedFoldAction({fold_id:item?.fold_id}).then(res=>{savedFoldListRefresh();if(item?.fold_id === checkingFold){setCheckingFold(null)}})}>确认删除</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )})} 
                        </div>    
                            :
                        <div className="w-full text-center p-4">
                            暂无内容
                        </div>
                    }
                </div>
            }
        </div>

        )
    }
    const dataSourceMap = {
        'nation_policy':'国务院政策库',
        'Brookings':'美国布鲁金斯学会',
        'Development_research_center':'国务院发展研究中心',
        'KDI':'韩国开发研究院'
    }
    const renderContentList = () => {
        return (
            <>
                {
                    savedContentLoading ? 
                    <div className="flex flex-col gap-4 w-full mb-2 p-4">
                        <div className="skeleton h-6 w-full"></div>
                        <div className="skeleton h-6 w-full"></div>
                        <div className="skeleton h-6 w-full"></div>
                    </div> : 
                    <>
                        {
                            savedContentData?.length > 0 ?
                            <>
                            {savedContentData?.map((item, index) => {return (
                                <div className='card card-bordered bg-base-100 mb-3'>
                                    <div className="card-body p-6">
                                        <div className='flex gap-4 justify-between -mt-4 -ml-7'>
                                            <div className="indexTag bg-">{dataSourceMap[item?.data_source]}</div>
                                        </div>
                                        <h2 className="card-title justify-center cursor-default hover:text-primary cursor-pointer"
                                            onClick={()=>{
                                                window.open(util.buildPolicyFileUrl(item?.title, item?.source_id, '', window.location.href),'_blank')
                                                // setContent(item?.content);document.getElementById('my_saved_content_modal').showModal()}
                                            }}                                        
                                        >
                                            {item?.title?.includes('[解读]') && <button className="btn btn-success btn-sm mr-2">解读</button>}
                                            {item?.title?.includes('[重要讲话]') && <button className="btn btn-warning btn-sm mr-2">重要讲话</button>}
                                            {item?.high_light_index && item?.high_light_index?.length > 0 && item?.high_light_index?.some(item=>item?.end_position === 0) ? 
                                            <span className="bg-yellow-200">{item?.title?.replace('[解读]','')?.replace('[重要讲话]','')}</span> : 
                                            item?.title?.replace('[解读]','')?.replace('[重要讲话]','')}
                                        </h2>
                                        <div className="card-actions justify-center">
                                            <div className="text-gray-500">{util.dateTransformToCN(item?.post_time)}</div>
                                        </div>
                                        <div className={`max-h-[4.5rem]  line-clamp-3 text-ellipsis`}>
                                            {item?.content}
                                        </div>
                                        <div className="card-actions justify-between items-center">
                                            <div className="flex-1 text-secondary">
                                                收藏时间 ：{util.dateTransformToCN(item?.save_time)}
                                            </div>
                                            <div>
                                                <button className="btn btn-ghost btn-sm" 
                                                onClick={()=>{
                                                    window.open(util.buildPolicyFileUrl(item?.title, item?.source_id, '', window.location.href),'_blank')
                                                    // setContent(item?.content);document.getElementById('my_saved_content_modal').showModal()}
                                                }}
                                                >
                                                    查看全文
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='1.5' stroke="currentColor" className="w-4 h-4">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                                    </svg>
                                                </button>
                                                <button className="btn btn-ghost btn-sm" onClick={()=>{
                                                            deleteSavedContentAction({
                                                                fold_id:checkingFold,
                                                                source_id:item?.source_id
                                                            })
                                                            .then(res=>{
                                                                // if(res){
                                                                    util.showToast('  ✓ 删除成功');
                                                                                                                                        savedFoldListRefresh();
                                                                    getSavedContentAction(checkingFold)
                                                                // }
                                                            })
                                                        }}>
                                                        取消收藏
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-warning">
                                                        <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
                                                        </svg>
                                                </button>

                                                {/* <div className="dropdown dropdown-top dropdown-end">
                                                    <div tabIndex={0} role="button" className="btn btn-ghost btn-sm">
                                                        取消收藏
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-warning">
                                                        <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>
                                                    <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-28">
                                                        <li><a onClick={()=>{
                                                            deleteSavedContentAction({
                                                                fold_id:checkingFold,
                                                                source_id:item?.save_id
                                                            })
                                                            .then(res=>{
                                                                if(res){
                                                                    util.showToast('  ✓ 删除成功');
                                                                    savedFoldListRefresh();
                                                                    getSavedContentAction(checkingFold)
                                                                }
                                                            })
                                                        }
                                                    }>确认取消</a></li>
                                                    </ul>
                                                </div> */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                )})} 

                            </>    
                                :
                            <div className="w-full text-center p-4">
                                暂无内容
                            </div>
    

                        }
                    </>

                }
            </>
        )
    }
    const pageBack = () => {
        const returnUrl = searchParams.get('returnUrl')
        if(returnUrl){
            window.location.href = returnUrl;
        }else{
            window.location.href = `${process.env.REACT_APP_DOMAIN}policy`
        }
    }
    
    return (
      <div className='w-full overflow-auto h-screen flex flex-col'>
        <div className="navbar bg-base-100 lg:px-6 p-4 rounded-box">
          <div className="flex-1">
            <span className='hover:primary cursor-pointer' onClick={()=>pageBack()}>返回</span>
            <div className="divider divider-horizontal"></div>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
            </svg>
            <div className="font-bold text-xl ml-2">个人收藏夹{savedFoldListData && ` · ${savedFoldListData?.length}`}</div>
          </div>
          {/* <label className="input input-bordered flex items-center gap-2 mr-4">
            <input type="text" className="grow w-24" placeholder="搜索" />
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="w-4 h-4 opacity-70"><path fillRule="evenodd" d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" clipRule="evenodd" /></svg>
            </label> */}
          <div className="flex-none">
            <button className='btn btn-outline' onClick={()=>{setEditingFold();document.getElementById('my_fold_form_modal').showModal()}}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
                </svg>
                新建收藏夹
            </button>
          </div>
        </div>
        <div className='flex-1 overflow-y-auto bg-base-100'>
            {
                checkingFold ? 
                <div className='lg:flex h-full overflow-y-auto'>
                    {renderFoldList()}
                    <div className="py-4 px-6 w-full h-full overflow-auto bg-base-200 hidden lg:block">
                        {renderContentList()}
                    </div>
                </div> :
                <>
                    {renderFoldList()}
                </>
            }
        </div>
        {/* <div className="drawer drawer-end drawer-open lg:hidden">
            <input id="my-saved-content-drawer" type="checkbox" className="drawer-toggle" />
            <div className="drawer-side">
                <label htmlFor="my-saved-content-drawer" aria-label="close sidebar" className="drawer-overlay"></label>
                <ul className="menu p-4 w-4/5 min-h-full bg-base-100 text-base-content">
                {renderContentList()}
                </ul>
            </div>
        </div> */}
        <SavedContent
            data={content}
        />
        <FoldFormModal
            foldData={editingFold}
            successAction={()=>{document.getElementById('my_fold_form_modal').close();savedFoldListRefresh()}}
        />
      </div>

    )
}